<script>
  import { onMount } from "svelte";
  import { fade } from "svelte/transition";
  let isVisible = false;

  onMount(() => {
    isVisible = true;
  });
</script>

<div class="background-animation">
  <div class="container">
    <div class="content-wrapper" in:fade={{ duration: 1000 }}>
      <!-- Title -->
      <h2 class="title pt-16">One tool to rule them all.</h2>

      <!-- Subtitle -->
      <p class="subtitle">
        Find videos you’ve lost, forgotten, or can’t track down — across 100s of
        carefully vetted free sites.
      </p>
      <!-- GIF -->
      <div class="gif-container">
        <img src="/radius.gif" alt="Search demonstration" class="demo-gif" />
      </div>

      <!-- Steps -->
      <!-- <h3 class="how-it-works pb-4">How it works:</h3>
      <div class="steps-container">
        <div class="step">
          <span class="step-number">1.</span>
          <span class="step-text">Type ...</span>
        </div>
        <div class="step">
          <span class="step-number">2.</span>
          <span class="step-text">Click ...</span>
        </div>
        <div class="step">
          <span class="step-number">3.</span>
          <span class="step-text">Find.</span>
        </div>
      </div> -->
    </div>
  </div>
</div>

<style>
  .background-animation {
    position: relative;
    min-height: 100vh;

    overflow: hidden;
  }

  .circle {
    position: absolute;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.03);
    animation: float 20s infinite linear;
    z-index: 1;
  }

  .circle1 {
    width: 400px;
    height: 400px;
    top: -100px;
    left: -100px;
    animation-delay: -5s;
  }

  .circle2 {
    width: 600px;
    height: 600px;
    bottom: -200px;
    right: -200px;
    animation-delay: -10s;
  }

  .circle3 {
    width: 300px;
    height: 300px;
    top: 50%;
    left: 50%;
    animation-delay: -15s;
  }

  @keyframes float {
    0% {
      transform: translate(0, 0) rotate(0deg);
    }
    33% {
      transform: translate(50px, 50px) rotate(120deg);
    }
    66% {
      transform: translate(-50px, 50px) rotate(240deg);
    }
    100% {
      transform: translate(0, 0) rotate(360deg);
    }
  }

  .container {
    position: relative;
    z-index: 2;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 16px;
    text-align: center;
    min-height: 90vh;
    display: flex;
    align-items: center;
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .title {
    font-size: 3.5rem;
    font-weight: bold;
    margin-bottom: 16px;
    color: #f0f0f0;
    line-height: 1.1;
  }

  .highlight {
    background-color: white;
    color: #1a1a1a;
    padding: 0 4px;
    font-size: 1em;
    line-height: 1.3;
    border-radius: 4px;
  }

  .tilted {
    display: inline-block;
    transform: rotate(-1deg);
  }

  .subtitle {
    font-size: 1.25rem;
    margin-bottom: 64px;
    color: gray;
  }

  .how-it-works {
    color: white;
    font-size: 1.5rem;
    margin-bottom: 8px;
    font-weight: 700;
    text-shadow: 0 1px 4px rgba(0, 0, 0, 0.18);
  }

  .steps-container {
    display: flex;
    flex-direction: column;
    gap: 28px;
    margin-top: 0;
    max-width: 600px;
    width: 100%;
    text-align: center;
  }

  .step {
    display: flex;
    align-items: center;
    gap: 12px;
    justify-content: center;
  }

  .step-number {
    color: #ffd700;
    font-size: 1.5rem;
    font-weight: bold;
    text-shadow: 0 1px 4px rgba(0, 0, 0, 0.18);
  }

  .step-text {
    color: #ededed;
    font-size: 1.25rem;
    font-weight: 500;
  }

  @media (max-width: 600px) {
    .title {
      font-size: 2.5rem;
      line-height: 1.2;
    }
    .highlight {
      font-size: 1em;
    }
    .step-text {
      font-size: 1.1rem;
    }
  }

  @media (min-width: 601px) {
    .subtitle {
      font-size: 1.5rem;
    }
  }

  .gif-container {
    width: 100%;
    max-width: 800px;
    margin: 0 auto 2rem;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  }

  .demo-gif {
    width: 100%;
    height: auto;
    display: block;
  }
</style>
